export default {
    public: {
        add: '新增',
        confirm: '确定',
        cancel: '取消',
        continue: '继续',
        success: '操作成功',
        delSuccess: '删除成功',
        copySuccess: '复制成功',
        downloadFileReady: '下载文件准备中',
        downloadFileReadyText: '准备工作会在后台进行，你可以选择进行其他操作或稍后前往下载文件',
        downloadCenter: '下载中心',
        view: '查看',
        fileReadyComplete: '文件已准备完成',
        today: '今天',
        recentThreeDays: '最近三天',
        recentOneWeek: '最近一周',
        recentOneMonth: '最近一个月',
        recentThreeMonths: '最近三个月',
        pleaseEnterKeywords: '请输入关键词',
        all: '全部',
        more: '更多',
        edit: '编辑',
        delete: '删除',
        doNotSubmitAgain: '请勿重复提交!',
        store: '店铺',
        customPleaseEnterComplete: '自定义渠道请录入完整信息！！！',
        pleaseSelectData: '请勾选数据',
        platform: '平台',
        name: '名称',
        price: '价格',
        craft: '工艺',
        size: '尺码',
        status: '状态',
        save: '保存',
        color: '颜色',
        noData: '暂无数据',
        remark: '备注',
        systemOperationDocument: '系统操作文档',
        startTime: '开始时间',
        endTime: '结束时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
        to: '至',
        operation: '操作',
        category: '分类',
        upload: '上传',
        createTime: '创建时间',
        reset: '重置',
        operationTime: '操作时间',
        order: '订单',
        no: '否',
        yes: '是',
        themeName: '主题名称',
        readThemeName: '读取产品对应语言的主题名称，若产品设置了店铺别名，将读取店铺别名。',
        blankProductName: '空白产品名称',
        readBlankProductName: '读取店铺对应语言的空白产品名称。',
        description: '空白产品描述',
        readDescription: '读取当前产品模板中所填写的产品描述。',
        tags: '产品标签',
        readTags: "读取全部产品标签，使用变量'{'tags'}'；\n" +
            "读取前几个产品标签，并加上后缀词，使用变量'{'tag+个数+后缀词'}'，如'{'tag5 t shirt'}'；\n" +
            "读取随机几个产品标签，并加上后缀词，使用变量'{'rtag+个数+后缀词'}'，如'{'rtag5 Case'}'",
        sizeName: '尺码名称',
        readSizeName: '模板中设置了自定义尺码名称时，将读取自定义名称。',
        brandName: '品牌',
        readBrandName: '读取当前模板中所填写的品牌名称。',
        pending: '待处理',
        designing: '设计中',
        designComplete: '设计完成',
        inProduction: '已入生产',
        qualityInspection: '质检中',
        delivery: '待发货',
        delivered: '已发货',
        cancelled: '已取消',
        processing: '处理中',
        processingText: '系统正在处理，请稍候...',
        maxNumData: '最多只能操作{maxNum}条数据',
    },

    home: {
        onlineDesign: '在线设计',
        submitOnline: '在线提交',
        regionLanguage: '区域语言',
        home: '首页',
        allSelect: '全部选品',
        workbench: '工作台',
        searchForProducts: '搜索商品',
        goLogin: '去登录',
        customOrder: '一件定制',
        generateOrder: '一件生成',
        deliveryOrder: '一件代发货',
        productCustomizable: '产品可定制',
        cumulativeFreeElements: '累计免费元素',
        startSelecting: '开始选品',
        efficientSelecting: '高效选品',
        efficientSelectingText: '平台提供丰富的定制产品供分销商挑选',
        designShelf: '设计上架',
        designShelfText: '优质素材，高效设计优质商品',
        efficientProduction: '高效生产',
        efficientProductionText: '订单同步，出单后派发工厂生产',
        oneClickDelivery: '一件代发货',
        oneClickDeliveryText: '足不出户很方便的完成订单交易',
        displayCustomerService: '显示客服',
        joinUS: {
            joinTitle: '加入我们，一起边玩边赚',
            joinText1: '你离赚钱只有一个',
            joinText2: '距离',
            ERPDeployIndependently: 'ERP独立部署',
            ERPDeployIndependentlyText: '独立部署ERP，无需依赖其他系统',
            exclusiveCooperation: '独家款合作',
            exclusiveCooperationText: '我们会提供一套完整的系统，教你生产一件定制的产品',
            trainingCooperation: '培训合作',
            trainingCooperationText: '用专业的能力为服务商提供领先、 安全、可靠、超乎想象的产品',
        },
        boutiqueRelease: {
            boutiqueReleaseTitle: '潮流精品发布 紧随市场热卖',
            boutiqueReleaseText: '追求柔性供应链最优解 支持代工',
            name: '名称',
            price: '售价'
        },
        categoryRich: {
            categoryRichTitle: '品类丰富',
            categoryRichText: '我们的产品品类丰富，满足不同客户的需求',
            viewMore: '查看更多',

            productMaterial: '产品材质',
            productWeight: '产品重量',
            productSize: '产品尺码',
            goToDesign: '去设计'
        },
        deployIndependently: {
            deployIndependentlyTitle: '系统独立部署 一站式柔性定制',
            deployIndependentlyText: '定制共享 生态共赢',
            contentText1: '接入自有物流账号',
            contentText2: '自主品牌设计/刊登/下单系统',
            contentText3: '个性定制生产系统',
            contentText4: '自有工厂产品接入，打造内部生产线',
            contentText5: '独立域名/独立模板/独立产品输出',
            contentText6: '一站式质检打单系统',
        },
        logisticsCooperation: {
            logisticsCooperationTitle: '全球各大电商平台销售',
            logisticsCooperationTitle1: '物流合作',
        },
        page_document: {
            contactUs: '联系我们',
            serviceHotline: '全国统一服务热线',
            MondayToSaturday: '周一至周六',
            contactCustomerService: '联系客服',
            addCustomerService: '扫码添加专属客服',
        },
    },

    login: {
        login: '登录',
        username: '用户名',
        password: '密码',
        rememberMe: '记住密码',
        register: '注册',
        resetPassword: '忘记密码',
        returnHome: '返回首页',
        agreeToTerms: '我已阅读并同意',
        termsOfUse: '用户协议',
        privacyPolicy: '隐私权政策',
        pleaseEnterPhoneNumber: '请输入手机号',
        pleaseEnterVerificationCode: '请输入验证码',
        getVerificationCode: '获取验证码',
        unregisteredWillCreateAccount: '未注册将自动创建DIYDO账号',
        pleaseEnterUsername: '请输入用户名',
        pleaseEnterCompanyName: '请输入公司名称',
        pleaseEnterPassword: '请输入密码',
        pleaseDragSliderToRight: '请按住滑块，拖动到最右边',
        verifySuccess: '验证成功',
        holdToSlideContinue: '按住继续滑动',
        loginSuccess: '登录成功',
        pleaseCompleteSlider: '请完成滑块验证后登录',
        registerTips: '注册后需联系客服激活账号',
        passwordNotSame: '两次输入密码不一致',
        pleaseEnterConfirmationPassword: '请输入确认密码',
        pleaseEnterAgainPassword: '请再次输入密码',

        pleaseEnterAccount: '请输入登录账号',
        pleaseEnterPhone: '请输入手机号',
        registerSuccess: '注册成功',
    },

    shop_list: {
        shopList: '选品库',
        productName: '选品名称',
        productSKU: '选品SKU',
        shopPrice: '￥{ price } 起',
        shippingArea: '发货地区',
        domesticShipping: '国内发货',
        internationalShipping: '国际发货',
        addNewProductDemand: '新增开版需求',
        imageException: '图片异常',
        expectDelivery: '预计发货',
        expectDeliveryTime: '2-4天发货',
        titleName: '标题名称',
        selectTaskTemplate: '选择任务模版',
        shop: '选品',
        selectEffectImage: '选择效果图',
        templateImage: '样板图',
        productReferenceLink: '产品参考链接',
        factoryPriceDemand: '出厂价需求',
        fabricMaterialDemand: '面料材质需求',
        remark: '备注说明',
        allCategory: '全部分类',
    },

    customs: {
        selectCustoms: '选品',
        customCustomsInfo: '自定义报关信息',
        selectProductName: '选品名称',
        productId: '选品ID',
        selectProductNumber: '选品编号',
        addProductCustomsInfo: '添加产品报关信息',
        customsTip: '平台预设产品报关信息，代理申报订单。若因申报关税或货物被海关扣押等引发的纠纷/损失，用户自行负责。',
        declareChineseName: '申报中文名称',
        size: '尺码',
        declareEnglishName: '申报英文名称',
        productMaterialEnglish: '产品材质(英文)',
        declarePriceUSD: '申报价格（USD）',
        declareWeightG: '申报重量（g）',
        customsCode: '海关编码',
        operation: '操作',
        addNewCustomsProduct: '新增报关产品',
        editCustomsInfo: '编辑报关信息',
        confirmDeleteCustomsInfo: '删除报关信息该选品将恢复默认，是否继续?',
        productName: '商品名称',
        productSku: '商品SKU',
        templateCategory: '模版分类',
        addNewCustomsInfo: '新增报关信息',
        selectAll: '全选',
        imageException: '图片异常',
        productAddCustomsInfo: '选品添加报关信息',
        batchImport: '批量录入',
        batchEdit: '批量编辑',
        country: '国家',
    },

    theme_requi: {
        selection: '选品',
        themeRequirement: '主题需求',
        themeName: '主题名称',
        creator: '创建人',
        elementProductionMethod: '元素制作方式',
        behalfOthers: '代制作',
        makeYourOwn: '自己制作',
        themeImage: '主题图片',
        completionStatus: '完成情况',
        pendDevelopment: '待开发',
        subThemeCompleted: '子主题开发完成',
        elementCompleted: '元素制作完成',
        completed: '已完成',
        remark: '备注',
        viewRemark: '查看主题备注',
        viewSubTheme: '查看子主题',
        operation: '操作',
        subThemeDownload: '子主题下载',
        themeRemark: '主题备注',
        subThemeInfo: '子主题信息',
        feeExplanation: '费用说明',
        themeNameExplanation: '主题名称说明',
        howMade: '制作方式',
        madeTip: '待制作为设计师代制作元素（收费标准如上）',
        behalfOthersTip: '请悉知，代制作是收费操作，详细收费标准请参照上方费用说明',
        notice: '注意',
        title: '标题',
        subThemeImage: '子主题图片',
    },

    product_list: {
        productManagement: '产品管理',
        myProducts: '我的产品',
        pendingGeneratedProducts: '待生成产品',
        productName: '产品名称',
        selectionSKU: '选品SKU',
        operator: '运营人',
        designer: '设计人',
        platformSKU: '平台SKU',
        designSKU: '设计SKU',
        productNumber: '产品编号',
        englishTheme: '英文主题',
        selectSubAccount: '选择子账号',
        selectAll: '全选',
        selectProductTemplate: '请选择产品模版',
        exportStatus: '汇出状态',
        exported: '已汇出',
        notExported: '未汇出',
        compositeProduct: '组合产品',
        unsold: '已下架',
        productBasicInfo: '产品基本信息',
        viewCompositeProduct: '查看组合产品',
        shippingCenter: '发货中心',
        tags: '标签',
        finishedSKU: '成品SKU',
        attachedImages: '附图',
        generating: '生成中',
        boundPlatformShopSKU: '已绑定平台/店铺/SKu',
        platformShop: '平台/店铺',
        unbind: '解绑',
        viewAll: '查看全部',
        createTime: '创建时间',
        productDetail: '产品详情',
        productEdit: '产品编辑',
        addToCart: '加入购物车',
        moreOperation: '更多操作',
        downloadHighDefinition: '下载高清',
        associateShop: '关联店铺',
        exportProduct: '产品汇出',
        manualAssociation: '手动关联',
        amazonExport: '亚马逊汇出',
        walmartExport: '沃尔玛汇出',
        ebayExport: '速卖通汇出',
        compositeProductInfo: '产品组合信息',
        compositeProductInfoTips: '不同工厂无法组合',
        batchExportTips: '批量汇出须属于同一模版，相同的模版sku',
        cannotAddToCart: '成品无法加入购物车',
        noPermission: '已选择元素您没有权限操作',
        confirmDeleteProducts: '删除我的产品，是否继续?',
        confirmUnbind: '确认解绑，是否继续?',
        englishTags: '英文标签',
        englishTagsTips: '英文标签以逗号隔开',
        updateTime: '更新时间',
        productElement: '产品元素',
        previewImageException: '抱歉预览图加载失败了',
        noData: '暂无数据',
        importantInformation: '重要信息',
        optionalInformation: '可选信息',
        productImage: '产品图片',
        platformShopSKU: '平台/店铺/SKU',
        originalImage: '原图',
        addNewShop: '新增店铺',
        SKURules: 'SKU规则',
        SKURandomCharacter: 'SKU随机字符',
        exportProductImage: '导出产品图',
        pleaseSelectShop: '请选择店铺',
        pleaseInputSKU: '请输入SKU 区分大小写',
        exportTip: "1.上传图片或/和文字时不得存在涉政、涉黄、侵权等违法行为，情节严重的将予以封号处理，感谢您的配合。",
        exportTip2: "2.若出现填写字段与亚马逊不一致，请前往亚马逊店铺重新下载最新模板导入，下载模板时务必选择单个国家。",
        exportProducts: '汇出产品',
        shop: '所属店铺',
        mainImage: '主图',
        setMainImage: '设为主图',
        removeImage: '移除',
        importantInfo: '重要信息',
        brand: '品牌',
        factory: '厂家',
        externalProductNumberType: '外部产品编号类型',
        retailPrice: '零售价',
        stock: '库存',
        optionalInfo: '可选信息',
        exportTemplate: '汇出模版',
        productTemplate: '产品模版',
        remark: '备注',
        productImageTips: '点击图片拖动，即可调整图片顺序！每个变种将分别按照以下顺序汇出图片',
        sellingForm: '售卖形式',
        pleaseSelectSize: '请选择尺码',
        singleProduct: '单品',
        sizeVariant: '尺码变体',
        colorVariant: '颜色变体',
        productVariant: '产品变体',
        productVariantTips: '将多个定制产品按照“合并数量”汇出成1个母产品；',
        colorVariantTips: '为了保证颜色唯一性，汇出的相同颜色将固定加上序号。',
        sizeVariantTips: '指定尺码汇出',
        blankProductName: '空白产品名称',
        size: '尺码',
        attributeCombination: '属性组合',
        namePlusSize: '名称加尺码',
        open: '开启',
        close: '关闭',
        openTips: '开启后汇出产品名称会自动添加尺码信息',
        insertVariable: '插入变量',
        name: '名称',
        variable: '变量',
        declaration: '声明',
        preview: '预览',
        longDescription: '长描述',
        sizePrice: '尺码零售价($)',
        priceSyncToSize: '价格同步至各尺寸',
        price: '售价($)',
        fillNumber: '填充号码',
        fillNumberTips: '多个填充号码录入时需换行依次填入框内',
        SKUQuantityTip: "*需要{ count1}个，已经录入{count2}个。号码会依次对应单品导出若不足{count3}个则汇出没有对应的单品号码会为空，若超出所需个数系统自动忽略。",
        inventory: '库存',
        shortDescription1: '短描述1',
        shortDescription2: '短描述2',
        shortDescription3: '短描述3',
        saveTemplate: '保存模版',
        previewVariable: '变量预览',
        pleaseInputVariableValue: '请先录入变量值',
        color: '颜色',
        quantity: '数量',
        addToCartQuantity: '添加购物车件数',
        maxAddToCartQuantityTips: '最大可添加{ max_nums }件商品，超出请联系客服下单',
        unitPrice: '单价($)',
        viewCart: '查看购物车',
        fullEntry: '请完整录入产品的尺码，数量信息',
        productInfo: '产品信息',
        compositeProductName: '组合产品名',
        notEnterCompositeProductNameTips: '不录入组合品名称则默认使用第一个组合品名称',
        batchEdit: '批量编辑',
        batchDelete: '批量删除',
        batchDownload: '批量高清下载',
        productExport: '产品汇出',
        walmartPlatformExport: '沃尔玛平台汇出',
        amazonPlatformExport: '速卖通平台汇出',
        combinationProducts: '组合产品',
        user_name: '所属用户',
    },

    wrmTemplate: {
        productLibrary: '产品库',
        exportProductTemplate: '汇出产品模版',
        templateName: '模版名称',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
        templateType: '模版类型',
        walmart: '沃尔玛',
        attributeCombination: '属性组合',
        createTime: '创建时间',
        deleteExportTemplateConfirm: '删除汇出模版是否继续？',
    },

    bank: {
        materialLibrary: '素材库',
        myGallery: '我的图库',
        englishName: '英文名称',
        chineseName: '中文名称',
        englishTag: '英文标签',
        ID: 'ID',
        pleaseSelectSubAccount: '请选择子账号',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
        material: '素材',
        noticeDisableWord: '注意禁词',
        shareToAllPlatform: '对全平台共享',
        specification: '规格',
        imagePixel: '图片像素',
        imageCategory: '图片分类',
        imageType: '图片类型',
        themeImage: '主题图',
        backgroundImage: '背景图',
        source: '来源',
        createTime: '创建时间',
        operation: '操作',
        uploadElement: '元素上传',
        editCategory: '编辑分类',
        editTag: '编辑标签',
        editImageInfo: '编辑图片信息',
        shareImage: '分享图片',
        noPermission: '已选择元素您没有权限操作',
        batchDeleteConfirm: '删除图片，是否继续?',
        uploadTips1: '将图片拖放到此处上传，或点击上传',
        uploadTips2: '为了保证图片的正常使用，仅支持30M以内jpg、jpeg、png格式图片上传。支持多张图片上传',
        uploadTips3: '上传图片或/和文字时不得存在涉政、涉黄、侵权等违法行为，情节严重的将予以封号处理，感谢您的配合。',
        uploadTips4: '仅支持jpg、jpeg、png格式图片上传',
        selectedImageMaterial: '已选图片素材',
        materialCategory: '素材分类',
        addTag: '添加标签',
        englishTheme: '英文主题',
        englishThemeTips: '英文主题为元素主题关键词',
        oneKeyEnterImageInfo: '一键录入图片信息',
        setCategory: '设置分类',
        oneKeySync: '一键同步',
        uploadImageInfo: '上传图片信息',
        img: "图片",
        uploadFailedImageInfo: '上传失败图片信息',
        reason: '失败原因',
        imageSizeTips: '图片过大，请上传不要超过30M的图片',
        shareAccount: '分享账号',
        uploadImage: '上传图片',
        changeTag: '更改标签',
        deleteImage: '删除图片',
        allCategory: '全部分类',
        deleteCategoryConfirm: '删除分类，是否继续？',
        imageSize: '图片大小',
    },

    forbidden_word: {
        prohibitedWords: '违禁词',
        localWordLibrary: '本地词库',
        cloudWordLibrary: '云词库',
        serialNumber: '序号',
        riskLevel: '风险等级',
        applicablePlatform: '适用平台',
        remark: '备注',
        schematicDiagram: '示意图',
        createPerson: '创建人',
        deleteForbiddenWordConfirm: '删除违禁词是否继续？',
        inputForbiddenWord: '输入禁词',
        inputForbiddenWordTips: '输入完请按回车即可生成标签',
        lowRisk: '低风险',
        mediumRisk: '中风险',
        highRisk: '高风险',
        allPlatform: '全平台',
        specifiedPlatform: '指定平台',
        addToCloudWordLibrary: '新增禁词库列表',
        pleaseAddRemark: '请添加备注',
        schematicDiagramTips: '仅支持上传单张图片,图片格式为PNG,JPG,最大不超过10M',
        uploadImageTips: '上传图片示意图',
        pleaseAddRemarkTips: '请录入禁词库后回车添加',
        onlySupportJpgPngFormat: '仅支持jpg、png格式图片上传',
        imageSizeTips: '仅支持10M以内图片上传',
        emptyTagTips: '禁词库标签为空，请确认已录入禁词库，回车生成了标签',
        commonData: '通用数据',
        goRelevantPage: '点击前往相关页面',
        myGallery: '我的图库',
        material: '图片素材',
        forbiddenWordLibrary: '禁词库',
    },

    single_element: {
        gallery: '图库',
        exportGallery: '出单图库',
        exportNum: '出单数量',
        material: '素材',
        materialName: '素材名称',
        designSKU: '设计SKU',
        specification: '规格',
        imagePixel: '图片像素',
        imageSize: '图片大小',
        exportProduct: '出单产品',
        viewOrder: '查看订单',
        order: '订单',
        productKeywords: '产品关键词',
        productSKU: '产品SKU',
        productCode: '产品编号',
        operator: '运营人',
        platformSKU: '平台SKU',
        productImage: '产品图片',
        attachments: '附图',
        themeNameEnglish: '主题名称（英文）',
        tags: '标签',
        orderNumber: '订单号',
        platformShopOperator: '平台/店铺/运营人',
        productNum: '产品数量',
        source: '来源',
    },

    workList: {
        workOrder: '工单',
        workOrderManagement: '工单管理',
        workOrderTitle: '工单标题',
        selectWorkOrderStatus: '选择工单状态',
        pending: '待处理',
        developed: '待开发',
        developing: '开发中',
        completed: '已完成',
        canceled: '已取消',
        addWorkOrder: '添加工单',
        urgent: '加急',
        open: '开启',
        close: '关闭',
        status: '状态',
        expectCompleteTime: '预计完成时间',
        actualCompleteTime: '实际完成时间',
        workOrderDescription: '工单描述',
        cancelWorkOrder: '取消工单',
        detailedDescription: '详细描述',
        cancelWorkOrderConfirm: '取消工单是否继续?',
        commentContent: '评论内容',
        commentUser: '评论人',
        commentTime: '评论时间',
    },

    deal_record: {
        statistics: '数据',
        transactionNumber: '交易编号',
        platformOrderNumber: '平台订单号',
        factoryOrderNumber: '工厂订单号',
        transactionType: '交易类型',
        selectSubAccount: '选择子账号',
        transactionStartTime: '交易开始时间',
        transactionEndTime: '交易结束时间',
        exportTransactionRecord: '导出交易记录',
        accountRecharge: '账户充值',
        systemOrderNumber: '系统订单号',
        transactionRecord: '交易记录',
        amount: '金额（元）',
        arrivalTime: '到账时间',
        createTime: '创建时间',
        balance: '余额（元）',
        cumulativeRecharge: '累计充值（元）',
        cumulativeExpenditure: '累计支出（元）',
        cumulativeCommission: '累计佣金（元）',
        commissionDetails: '佣金详情',
        orderCommission: '订单佣金（元）',
        logisticsCommission: '物流佣金（元）',
    },

    distribution_data: {
        statistics: '数据',
        distributionData: '分销数据',
        transactionStartTime: '交易开始时间',
        transactionEndTime: '交易结束时间',
        totalSalesAmount: '总销售额（元）',
        totalProfit: '共计盈利（元）',
        companyName: '公司名称',
        shippingChannel: '发货渠道',
        distributionFee: '分销费用（元）',
        createTime: '创建时间',
        distributorTotalSalesAmount: '分销商共计销售额（元）',
        distributorTotalProfitRatio: '分销商累计收益占比（%）',
    },

    order_data: {
        statistics: '数据',
        orderData: '订单数据',
        statisticsType: '统计方式(维度)',
        date: '日期',
        shop: '店铺',
        finishedProduct: '成品',
        selectedProduct: '选品',
        platform: '平台',
        subAccount: '子账号',
        orderStatus: '订单状态',
        totalSalesAmount: '总销售额（$）',
        totalOrderNum: '总订单数',
        totalOrderItemNum: '总订单件数',
        averagePricePerItem: '平均每件价格（$）',
        orderNum: '订单数',
        orderItemNum: '订单产品件数',
        averageSalesPerItem: '每件平均销售额（$）',
    },

    product_data: {
        statistics: '数据',
        productData: '产品数据',
        startTime: '开始时间',
        endTime: '结束时间',
        productStatistics: "定制产品数据统计（总计{ count }件）",
        rank: '排名',
        productNum: '定制产品数量',
        account: '账号',
        viewProductDetail: '查看产品详情 ',
    },

    design_record: {
        productLibrary: '产品库',
        designRecord: '设计记录',
        customSKU: '自定义SKU',
        user: '用户',
        templateTitle: '模板标题',
        pass: '通过',
        notPass: '未通过',
        generated: '已生成',
        waitAudit: '待审核',
        generating: '生成中',
        from: '来源',
        designLibrary: '设计库',
        order: '订单',
        serialNumber: '序号',
        templateSKU: '模版SKU',
        status: '状态',
        userDesignImg: '用户设计图',
        effectImg: '效果图数据',
        operation: '操作',
        createTime: '创建时间',
        designAudit: '设计审核',
        regenerate: '重新生成',
        deleteDesign: '删除设计',
        auditDesignRecord: '审核设计记录',
    },

    tuku_data: {
        statistics: '数据',
        tukuStatistics: '图库统计',
        subAccount: '子账号',
        imgStatistics: '图片上传数量统计（总计{ count }张）',
        rank: '排名',
        uploadNum: '上传数量',
        uploadAccount: '上传账号',
    },

    com_cash: {
        statistics: '数据',
        withdrawalRecords: '提现记录',
        inputOrderNumber: '输入订单编号',
        commissionType: '佣金类型',
        orderCommission: '订单佣金',
        logisticsCommission: '物流佣金',
        logisticsReturnFee: '物流返还费用',
        withdrawalType: '提现方式',
        alipay: '支付宝',
        bankCard: '银行卡',
        wechat: '微信',
        balance: '余额',
        currentStatus: '当前状态',
        pendingReview: '待审核',
        reviewPassed: '审核通过',
        reviewRejected: '审核驳回',
        paid: '已打款',
        transactionStartTime: '交易开始时间',
        transactionEndTime: '交易结束时间',
        totalCommissionBalance: '总佣金余额：{count} 元',
        orderCommissionBalance: '订单佣金余额：{count}元',
        logisticsCommissionBalance: '物流佣金余额：{count}元',
        orderNumber: '订单编号',
        withdrawAmount: '提现金额（元）',
        withdrawalAccount: '提现账号',
        remark: '备注',
        createTime: '创建时间',
    },

    frozen_list: {
        systemOrderNumber: '系统单号',
        statistics: '数据',
        frozenAmount: '冻结金额',
        platformOrderNumber: '平台订单号',
        factoryOrderNumber: '工厂订单号',
        transactionType: '交易类型',
        factoryProductionFee: '工厂制作费用',
        logisticsFee: '订单物流费用',
        transactionStartTime: '交易开始时间',
        transactionEndTime: '交易结束时间',
        exportFrozenList: '导出',
        totalFreezeAmount: '总冻结金额：{count} 元',
        productionFeeFrozen: '制作费冻结金额：{count} 元',
        logisticsFeeFrozen: '物流费冻结金额：{count} 元',
        frozenQuantity: '冻结件数',
        operator: '操作人',
        operationTime: '操作时间',
    },

    allProducts: {
        searchTips: '平台精选，品质保证，精选产品',
        explore: '探 索',
        imageException: '图片异常',
        craft: '工艺',
        material: '材质',
        sizeNum: '尺寸数',
        weight: '重量',
        category: '分类',
        expectDeliveryTime: '预计发货时间',
        topicZone: '专题专区',
        allCategory: '全部分类',
    },

    shopDetail: {
        salesPromotion: '此商品正在促销',
        endTime: '截止至',
        month: '月',
        day: '日',
        productPriceException: '商品价格异常，请联系客服！',
        shippingTips: '发货时间与件数有关，以实际交付时间为准',
        noSizeWeightInfo: '暂无尺码重量信息！',
        weightIncludePackaging: '重量（含包装）',
        shippingCenter: '发货中心',
        viewAddress: '查看地址',
        color: '颜色',
        size: '尺码',
        priceTip: '由于当前商品不同颜色、尺码的生产成本不同，其单价也会不同',
        noSizeInfo: '暂无尺码信息！',
        amazonSameProduct: '亚马逊同款产品',
        design: '我要设计',
        basicInfo: '基本信息',
        otherDescription: '其他描述',
        designDescription: '设计说明',
        sizeInfo: '尺码信息',
        packageInfo: '包装信息',
        name: '名称',
        englishName: '英文名称',
        productCode: '产品编码',
        productMaterial: '产品材质',
        productCraft: '产品工艺',
        factory: '制作工厂',
        shippingTime: '预计发货时间',
        hour: '小时',
        notice: '温馨提示',
        noticeText: '该图片展示效果仅供参考，最终效果以实物为准！由于生产批次、机器设备等客观因素原因，难以避免或将存在微小色差、位置及大小等误差，如遇以上问题均属于正常现象，将不予纳入售后处理范畴。',
        materialDescription: '材质说明',
        accessoryConstruction: '配件构造',
        productPerformance: '产品性能',
        applicableScenarios: '适用情景',
        washDescription: '洗涤说明',
        specialNotice: '特别说明',
        designArea: '设计区域',
        imageRequirements: '图片要求',
        packageSizeCm: '包装尺寸（cm）',
        lengthWidthHeight: '（长*宽*高）',
        packageSizeIn: '包装尺寸（in）',
        packageVolumeCm3: '包装体积（cm³）',
        packageVolumeIn3: '包装体积（in³）',
        weightIncludePackagingG: '含包装重量（g）',
        weightIncludePackagingLb: '含包装重量（lb）',
        orderNow: "现在下单，预计{time}小时发货",
        costCalculation: '成本试算',
        packingName: '包装名称',
    },

    order: {
        order: '订单',
        myOrder: '我的订单',
        orderExpiration: '超过三十天未处理的订单，系统将自动取消',
        authorizationExpires: '{ expired_nums }个店铺授权过期',
        auditApplicationDesign: '审核申请设计',
        mergeOrderList: '可合并发货列表',
        multipleSearchItems: '多个搜索项请以中英文逗号或者回车键隔开，最多支持100个搜索项',
        clear: '清空',
        close: '关闭',
        search: '搜索',
        preciseSearches: '多项精准搜索',
        systemOrderNumber: '系统订单号',
        platformOrderNumber: '平台单号',
        orderProductName: '订单产品名',
        createUser: '创建人',
        operator: '运营人',
        designer: '设计人',
        importTrackingNum: '导入物流单号',
        customSKU: '定制SKU',
        customOrderDetails: '定制订单详情',
        thirdPartyLogistics: '第三方物流',
        walmartPurchaseNumber: '沃尔玛采购单号',
        mergeBatchNumber: '合并批次号',
        selectSubAccount: '选择子账号',
        all: '全选',
        pleaseSelectCraft: '请选择工艺',
        logisticsMergeInfo: '物流合并信息',
        logisticsNotMerged: '物流未合并',
        logisticsMerged: '物流已合并',
        choose: '请选择',
        importDate: '导入日期',
        platformOrderTime: '平台下单时间',
        platformShippingTime: '平台发货时间',
        updateTime: '更新时间',
        systemShippingTime: '系统发货时间',
        startTime: '开始时间',
        endTime: '结束时间',
        to: '至',
        pleaseSelectPlatform: '请选择平台',
        pleaseSelectStore: '请选择店铺',
        whetherHasLabel: '是否有面单',
        hasLabel: '有面单',
        noLabel: '没有面单',
        noImage: '暂无图片',
        productName: '产品名称',
        SKUItemNumber: 'SKU货号',
        specification: '规格',
        quantity: '数量',
        associatedProducts: '关联产品',
        exceptionOrderProducts: '异常订单产品',
        compositeProducts: '组合产品',
        designInProcess: '设计中',
        name: '名称',
        price: '售价',
        quantityEdit: '数量编辑',
        stockUpProductSKU: '备货产品SKU',
        stockUpInventory: '备货库存',
        productNumber: '产品编号',
        compositeProductID: '组合产品ID',
        craft: '工艺',
        size: '尺码',
        platformSize: '平台尺码',
        status: '状态',
        expectedDeliveryTime: '预计交货时间',
        customInfo: '定制信息',
        goToDesign: '去设计',
        reDesign: '重新设计',
        modifyAssociated: '修改关联',
        applyDesign: '申请设计',
        deleteOrderProduct: '删除订单产品',
        viewProductionNotes: '查看生产备注',
        productPayment: '产品货款',
        shippingFee: '运费',
        frozenShippingFee: '冻结运费',
        total: '总计',
        profitMargin: '利润率',
        contactPerson: '联系人',
        contactPhone: '联系电话',
        warehouseAddress: '仓库地址',
        trackingNumber: '转运单号',
        shippingDays: '运输天数',
        deliveryDays: '妥投天数',
        logisticsNotUpdated: '物流{days_after_last_update}天未更新',
        logisticsTrack: '物流轨迹',
        platformLatestShippingTime: '平台最晚发货时间',
        importSystemTime: '导入系统时间',
        productPaymentTime: '生产支付时间',
        copyOrder: '复制订单',
        createPreShipping: '创建预发货',
        handleException: '处理异常',
        applyAfterSales: '申请售后',
        getTrackingNumber: '获取包裹号',
        modifyAddress: '修改地址',
        restoreOrder: '恢复订单',
        cancelOrder: '取消订单',
        applyInterception: '申请物流拦截',
        syncLogistics: '马势同步物流',
        viewLabel: '查看面单',
        orderDetails: '订单详情',
        shippingMethod: '发货方式',
        FBAShipping: 'FBA发货',
        selfPickup: '自提',
        suspectedPhishing: '疑似钓鱼',
        phishingAddress: '钓鱼地址',
        mergedShipping: '已合并发货',
        shippingCenter: '发货中心',
        platform: '平台',
        store: '店铺',
        receiver: '收货人',
        phoneNumber: '手机号',
        recipient: '收件人',
        postCode: '邮编',
        detailedAddress: '详细地址',
        detailedAddress2: '详细地址2',
        salesVolume: '销售额',
        logistics: '物流',
        time: '时间',
        operation: '操作',
        createShipping: '创建发货单',
        enterProductionInfo: '录入生产信息',
        mergeShipping: '合并发货单',
        batchCreateShipping: '批量创建发货单',
        importCustomInfo: '导入定制信息',
        generateFBAItem: '生成FBA货件',
        modifyProductQuantity: '修改订单产品数量',
        syncFullCustodyShipping: '同步全托发货台',
        createOut: '创建出库',
        payProductPayment: '支付货款',
        batchImportLabels: '批量导入面单',
        importLogisticsNumber: '导入物流单号',
        importOrder: '导入订单',
        mergeShipping1: '合并发货',
        createFBAItem: '创建FBA货件',
        sheinCustomInfo: "希音定制信息",
        temuCustomInfo: "temu定制信息",
        logisticsExport: '物流导出',
        walmartLogisticsExport: '沃尔玛物流导出',
        moreOperation: '更多操作',
        batchExportOrders: '批量导出订单',
        batchPreShipping: '批量预发货',
        batchCancelOrder: '批量取消订单',
        exportShippingCost: '导出花费',
        country: '国家',
        city: '城市',
        state: '州',
        mailbox: '邮箱',
        pleaseEnterPhoneNumber: '请输入手机号',
        phoneNumberFormatIncorrect: '手机号格式不正确',
        pleaseEnterEmailAddress: '请输入正确的邮箱地址',
        quantitySelected: '已选择 { count } 单',
        payableNum: '可支付{ count }单',
        unPayableNum: '不可支付{ count }单',
        resultPreview: '结果预览',
        payable: '可支付',
        unPayable: '不可支付',
        orderNumber: '订单号',
        orderPayment: '订单货款',
        viewDetail: '查看明细',
        orderProduct: '订单产品',
        unitPrice: '单价(￥)',
        totalPayment: '总计(￥)',
        orderStatus: '订单状态',
        description: '说明',
        paymentMethod: '支付方式',
        accountBalance: '账户余额',
        availableBalance: '可用余额(￥)',
        recharge: '充值',
        payableAmount: '应付金额(￥)',
        pay: '支付',
        pleaseSelectOrder: '请勾选订单去支付',
        orderPaymentException: '订单货款存在异常，请联系客服',
        payOrderPayment: '支付货款，是否继续?',
        mergedShippingSameStoreSameAddress: '合并发货必须是相同店铺购买并且同一收货地址',
        orderID: '订单ID',
        platformStore: '平台店铺',
        requiredShippingTime: '要求发货时间',
        copyAllOrderID: '复制全部订单号',
        ShippingTimeRequired: '要求发货时间必填',
        Shein: '希音',
        Temu: 'temu',
        shippingOrderCreateTime: '发货单创建时间',
        endDate: '结束日期',
        startDate: '开始日期',
        whetherCover: '是否覆盖？',
        pleaseSelectSyncTime: '请选择同步时间',
        productFnsku: '产品fnsku',
        platformSku: '平台SKU',
        generateTip: '* 详情请至 FBA =》 发货列表 查看详情',
        pleaseSelectType: '请选择类型',
        shipmentInfo: '货件信息',
        orderProducts: '订单产品',
        systemNoOrderID: '系统无单号',
        systemHasLogisticsNumber: '系统有物流单号',
        procedureTip: "操作步骤：登录第三方平台后台下载需要发货的面单，面单文件命名为： 平台订单号{'@'}运单号； 若导入的订单表格已包含运单号，可直接用运单号命名（如果面单已存在，新导入的面单会覆盖原有面单）USPS面单尺寸建议：4*6inch",
        procedureTip1: '操作步骤：下载模版录入平台订单号，物流单号，进行导入。然后面单文件命名为： 运单号.pdf后，继续上传面单文件',
        goImportLogisticsNumber: '去导入物流单号',
        keywordSearch: '关键字快捷搜索',
        dragAndDropFile: '将文件物流面单PDF文件拖到这里上传',
        clickUpload: '点击上传',
        pleaseUploadPDFFile: '请上传PDF文件',
        successfullyImported: '成功导入{ count }个',
        failedImport: '导入失败{ count }个',
        failedReason: '失败原因',
        pleaseUploadWaybill: '请上传面单',
        pleaseUploadTxtXlsxXlsFormat: '请上传.txt, .xlsx, .xls格式文件',
        pleaseUploadCustomInfoFile: '请上传定制信息文件',
        downloadTemplate: '下载模板',
        import: '导入',
        pleaseImportLogisticsNumber: '请导入物流单号',
        logisticsChannels: '物流渠道',
        deliver: '发货方式',
        goChannel: '前往设置物流渠道',
        logisticsNumber: '物流单号',
        logisticsWaybill: '物流面单',
        importLogisticsWaybill: '导入物流面单',
        pleaseUploadLogisticsWaybill: '请上传物流面单.pdf,.zip格式',
        systemAgent: '系统代理',
        ownChannel: '自有渠道',
        proxyChannel: '代理渠道',
        confirmDesignComplete: '该产品状态为设计完成，修改定制信息产品需要重新设计，是否继续?',
        preShippingCreated: '已创建预发货，如需修改请联系平台客服',
        orderInfo: '订单信息',
        shippingAddress: '收货地址',
        customsInformation: '报关信息',
        logisticsInformation: '物流信息',
        transactionInformation: '交易信息',
        exceptionOrderProduct: '异常订单产品',
        combinedProduct: '组合产品',
        orderProductIdentifier: '订单产品标识',
        stock: '备货库存',
        combinedProductID: '组合产品ID',
        productionStatus: '生产状态',
        goProductionTime: '去生产时间',
        deliveryTime: '交货时间',
        pendingProcessing: '待处理',
        designInProgress: '设计中',
        designComplete: '设计完成',
        inProduction: '已入生产',
        qualityInspection: '质检中',
        pendingShipping: '待发货',
        delivered: '已发货',
        cancelled: '已取消',
        shipping: '配货中',
        remoteAddress: '偏远地址',
        province: '省',
        pleaseCorrectEmailAddress: '请输入正确的邮箱地址',
        selectedProductName: '选品名称',
        chineseName: '中文名称',
        englishName: '英文名称',
        material: '材质',
        declarePrice: '申报价格',
        declareWeight: '申报重量(g)',
        customsCode: '海关编码',
        remark: '备注',
        declareRemark: '1、平台预设产品报关信息，代理申报订单。若因申报关税或货物被海关扣押等引发的纠纷/损失，用户自行负责。',
        declareRemark1: '2、您可以自定义产品的报关信息，',
        declareRemark2: '（相同的空白产品，合并申报）',
        clickGo: '点击前往',
        createLogisticsNumber: '创建运单号',
        recentLogisticsTrack: '最近物流轨迹',
        transactionType: '交易类型',
        transactionNumber: '交易编号',
        amountInYuan: '金额（元）',
        factoryOrderNumber: '工厂订单号',
        arrivalTime: '到账时间',
        frozenType: '冻结类型',
        OrderLogisticsFee: '订单物流费用',
        frozenQuantity: '冻结件数',
        frozenAmountInYuan: '冻结金额（元）',
        operationTime: '操作时间',
        copyOrderConfirm: '复制订单，是否继续?',
        getWaybillNumber: '获取包裹号，是否继续?',
        deleteOrderProductConfirm: '删除订单产品（若订单没有产品，该订单会被删除！），是否继续?',
        recoverOrderToPendingProcessing: '恢复订单到待处理，是否继续?',
        batchCancelOrderConfirm: '批量取消订单，是否继续?',
        syncLogisticsConfirm: '同步物流，是否继续?',
        syncLogisticsTip: '已选项中包含非FBA发货订单',
        cancelOrderConfirm: '即将取消订单，是否继续?',
        cancelOrderTip: '订单已入工厂，取消将扣除工厂费用，是否继续?',
        Y2OrderCancelConfirm: 'Y2订单取消是否继续?',
        synchronousTKFaceSheet: '同步TK面单',
        batchGetTKFaceSheetConfirm: '批量获取TK面单，是否继续?',
        batchGetTEMUFaceSheetConfirm: '批量获取TEMU面单，是否继续?',
        reDesignBindProductWillUnbind: '重新设计后已绑定产品将会自动解绑',
        pleaseNote: '请注意',
        pleaseNoteTip: '请在新开的页面完成商品设计，若提前关闭此窗口，请设计后手动刷新页面。',
        tipsWarmPrompt: '温馨提示',
        pleaseNoteTip1: '如需上传自定义面单，请在支付前创建，支付后不支持修改物流面单。',
        batchExportProduct: '批量导出产品',
        keywordSearches: '最多支持100个关键字搜索',
        logisticsFiveNotUpdated: '物流五天未更新',
        platformOrder: '平台订单',
        mergeShippingList: '可合并发货列表',
        pleaseNoteLogisticsWaybill: '请注意物流面单只可查看俩次，是否继续?',
        platformSearch: '平台搜索',
        addStore: '新增店铺',
        importQuantity: '导入数量',
        skipQuantity: '跳过数量',
        file: '文件',
        fileDownload: '文件下载',
        account: '账号',
        createTime: '创建时间',
        getTEMUSheetsInBulk: '批量获取TEMU面单',
        getOZONSheetsInBulk: '批量获取OZON面单',
        OZONBulkMarkShipments: 'OZON批量标记发货',
        goodsID: '货号ID',
        mergeOrder: '合并订单',
        pleaseSelectSameStoreOrder: '请选择相同店铺订单',
        mergeOrderConfirm: '请注意，合并订单后被合并订单将被删除且无法恢复，继续合并?',

        splitOrder: '拆分产品',
        productQuantity: '产品数量',
        splitQuantity: '拆分数量',
        split: '拆分',
        product: '产品',
        sizeInfo: '尺码信息',
        color: '颜色',
        pleaseSelectColor: '请选择颜色',
        pleaseEnterQuantity: '请录入数量',

    },

    merge: {
        order: '订单',
        mergeShippingRecord: '合并发货记录',
        batchNumber: '批次号',
        orderNumber: '订单号',
        waybillNumber: '运单号',
        operator: '运营人',
        sheinShippingBatchNumber: '希音发货批次号',
        TEMUShippingBatchNumber: 'TEMU发货批次号',
        logisticsChannel: '物流渠道',
        store: '店铺',
        createTime: '创建时间',
        requireShippingTime: '要求发货时间',
        againMerge: '再次合并',
        platformReserveShipping: '平台预约发货',
        platformShippingBatchNumber: '平台发货批次号',
        againMergeBatchNumber: '再次合并批次号',
        totalMerge: '共计合并：{ length }单, 共计：{ total_quantity }件',
        orderInfo: '订单信息',
        processQuantity: '工艺/件数：{render_type}/{quantity}件',
        shipments: '发货',
        type: '类型',
        expressOrder: '加急订单',
        normalOrder: '普通订单',
        orderTime: '下单时间',
        requireLatestShippingTime: '要求最晚发货时间',
        deliveryDate: '送达日期',
        viewAll: '查看全部',
        operationInfo: '运营信息',
        platform: '平台',
        creator: '操作人',
        userInfo: '用户信息',
        userName: '用户名称',
        email: '邮箱',
        recipient: '收件人',
        addressInfo: '地址信息',
        time: '时间',
        operation: '操作',
        cancelAgainMerge: '取消再次合并',
        cancelMerge: '取消合并',
        uploadTEMUExpressFile: '上传TEMU加急文件',
        pleaseSelectOrder: '请选择订单',
        cancelAgainMergeConfirm: '取消再次合并，是否继续?',
        mergeBatchConfirm: '合并批次，是否继续?',
        cancelMergeShippingConfirm: '取消合并发货，是否继续?',
        uploadFiles: '上传文件',
        temuExpressFile: 'TEMU加急文件',
        pleaseUploadPdfFormat: '请上传.pdf格式文件',
        reservePickupTime: '预约取件时间',
        suggestReservePickupTime: '建议预约取货时间设置在{ latest_ship_date }前',
        packageTotalQuantity: '包裹总数',
        packageWeight: '重量(kg)',
        estimatedWeight: '预计重量：{ estimated_weight }kg',
        logisticsCompany: '物流公司',
        estimatedFee: '预估费用',
        query: '查询',
    },

    process: {
        order: '订单',
        processOrder: '加工订单',
        productionStatus: '制作状态',
        inProduction: '制作中',
        productionComplete: '已制作',
        cancel: '已取消',
        processedProduct: '加工产品',
        elementPicture: '元素图片',
        processedQuantity: '加工数量',
        craft: '工艺',
        whiteInkTemperingPainting: '白墨烫画',
        chiffonDyeing: '密绣',
        pasteFabDyeing: '贴布绣',
        knittedCapSeamMarking: '针织帽缝标',
        status: '状态',
        remark: '备注',
        creator: '创建人',
    },

    intercept_order: {
        order: '订单',
        logisticsInterception: '物流拦截',
        orderNumber: '订单号',
        status: '状态',
        pending: '待处理',
        interceptionSuccess: '已拦截',
        interceptionFailed: '拦截失败',
        completed: '已完成',
        applyStartTime: '申请开始时间',
        applyEndTime: '申请结束时间',
        processingMethod: '处理方式',
        factoryDestroy: '工厂销毁',
        returnToSpecifiedAddress: '寄回指定地址',
        viewAddress: '查看地址',
        logisticsNumber: '物流单号',
        logisticsFee: '物流费用',
        applyPerson: '申请人',
        applyInterceptionTime: '申请拦截时间',
        operation: '操作',
        log: '日志',
        pleaseSelectStatus: '请选择状态',
        cancelSuccess: '取消拦截成功',
        cancelFailed: '取消拦截失败',
        pleaseSelectProcessingMethod: '请选择处理方式',
        interceptionSuccessQuantity: '拦截成功数量',
        interceptionFailedQuantity: '拦截失败数量',
        cancelInterception: '取消拦截',
        interceptionProgress: '拦截进度',
        cancelInterceptionConfirm: '取消物流拦截，是否继续?',
        date: '日期',
        userName: '姓名',
        progress: '进度',
    },

    trial_freight: {
        orderNumber: '订单号',
        trialFreight: '试用运费',
        logisticsChannel: '物流渠道',
        selectProduct: '选择产品',
        size: '尺码',
        weight: '重量',
        expandAllSize: '展开全部尺码',
        unitWeightGoods: '货物单件重量(kg)',
        quantity: '数量',
        calculateQuantity: '试算货物数量',
        calculate: '计算',
        notice: '现仅提供美国地区的运费试算。试算运费、妥投时效和妥投率仅供参考，以实际下单为准。',
        serialNumber: '序号',
        logisticsMethod: '物流方式',
        price: '价格(元)',
        noticeTip: '根据您的包裹信息计算得出仅供参考，实际费用以物流商计算为准(不含燃油附加费、税费等)',
        billingWeight: '计费重(g)',
        deliveryTime: '妥投时效(天)',
        deliveryTimeTip: '50%包裹妥投时间~90%包裹妥投时间;妥投时效仅供参考，以实际订单的实际物流时效为准',
        deliveryRate: '妥投率(%)',
        deliveryTip: '确认妥投的订单百分比',
        logisticsTip: '物流说明',
    },

    temu_custom: {
        order: '订单',
        importTEMUCustomInfo: '导入TEMU定制信息',
        importCustomInfoZip: '导入定制信息（Zip）',
        importCustomInfoExcel: '导入定制信息（Excel）',
        status: '状态',
        unparsed: '未解析',
        parsed: '已解析',
        store: '店铺',
        file: '文件',
        fileDownload: '文件下载',
        operation: '操作',
        analysisCustomization: '解析定制',
        importCustomInfo: '导入定制信息',
    },

    afterSalesList: {
        order: '订单',
        afterSalesManagement: '售后管理',
        orderNumber: '订单号',
        afterSalesType: '售后类型',
        refund: '退款',
        returnRefund: '退货退款',
        resend: '补发',
        status: '状态',
        pending: '待处理',
        confirmed: '已确认',
        completed: '已完成',
        auditPassed: '审核通过',
        auditRejected: '审核驳回',
        afterSalesOrderInfo: '售后订单信息',
        productName: '商品名称',
        productImage: '产品图片',
        afterSalesAmount: '售后金额(元)',
        applyAfterSalesAmount: '申请售后金额',
        actualAfterSalesAmount: '实际售后金额',
        afterSalesReason: '售后原因',
        afterSalesInstruction: '售后说明',
        submitPerson: '提交人',
        updateTime: '更新时间',
        operation: '操作',
        view: '查看',
        viewAfterSalesDetail: '查看售后详情',
    },

    blackList: {
        blackList: '黑名单',
        addressBlacklist: '地址黑名单',
        clientBlacklist: '客户黑名单',
        ruleName: '规则名称',
        contain: '包含',
        equal: '等于',
        operationInfo: '操作信息',
        operationPerson: '操作人',
        createInfo: '创建信息',
        createPerson: '创建人',
        embodyTip: '包含：只需匹配其中1个词组，等于：必须完全匹配',
        blackListAddTip: '黑名单录入完毕后，请点击回车键进行添加',
        tagAddTip: '标签录入完毕后，请点击回车键进行添加',
        remark: '备注',
        provinceState: '省份/州',
        city: '城市',
        address: '地址',
        postcode: '邮政编码',
        store: '店铺',
    },

    store: {
        storeManagement: '店铺管理',
        normalStatus: '正常',
        disabledStatus: '禁用',
        storeName: '店铺名称',
        pleaseEnterStoreName: '请输入店铺名称',
        pleaseSelectCountry: '请选择国家',
        authorizationStatus: '授权状态',
        addStore: '新增店铺',
        editStore: '编辑店铺',
        storeInfo: '店铺信息',
        platform: '平台',
        status: '状态',
        defaultShippingWarehouse: '默认发货仓',
        syncInfo: '同步信息',
        delayTimeForOnlineOrders: '在线下单延迟时间',
        productSKUAssociation: '商品SKU关联',
        onlineOrderDelayTime: '在线下单延迟时间',
        operator: '运营人',
        createTime: '创建时间',
        operation: '操作',
        authorized: '已授权',
        unauthorized: '未授权',
        authorizationException: '授权异常',
        noAuthorizationRequired: '无需授权',
        exceptionReason: '异常原因',
        reset: '重置',
        fullCustody: '全托',
        halfCustody: '半托',
        email: '邮箱',
        firstSyncTime: '首次同步时间',
        edit: '编辑',
        complianceFile: '合规文件',
        shippingConfiguration: '发货配置',
        more: '更多',
        licensedByShein: '希音授权',
        cancelAuthorization: '取消授权',
        shopProducts: '店铺商品',
        addMallID: '添加mallid',
        delete: '删除',
        number: '编号',
        region: '地区',
        brand: '品牌',
        synchronizeInfo: '同步信息',
        automaticallySyncOrders: '自动同步订单',
        yes: '是',
        no: '否',
        syncOrderStatus: '同步订单状态',
        pendingProcessing: '待处理',
        pendingShipping: '待发货',
        ifBoundShippingCenter: '若绑定发货中心，根据发货中心匹配仓库，若没有绑定，默认获取默认仓库',
        pleaseSetWarehouse: '请设置仓库',
        all: '全部',
        deleteStoreTip: '店铺删除后无法恢复，是否继续？',
        operationSuccess: '操作成功',
        cancelAuthorizationTip: '取消店铺授权，是否继续？',
        product: '产品',
        day: '天',
        pleaseSelectPlatform: '请选择平台',
        hostingMethod: '托管方式',
        productInventoryToken: '产品库存Token',
        getProductInventoryToken: '进入TEMU卖家中心【服务市场-授权管理】获取产品库存Token',
        getToken: '获取Token',
        orderShippingToken: '订单发货Token',
        US: '美区',
        goToSellerCentralUS: '前往Seller Central美国获取Token',
        global: '全球',
        goToSellerCentralGlobal: '前往Seller Central全球（除美区，欧区）获取Token',
        EU: '欧区',
        goToSellerCentralEU: '前往Seller Central欧区获取Token',
        country: '国家',
        affiliatedOperator: '所属运营人',
        pleaseSelectOperator: '请选择所属运营人',
        storeBrand: '店铺品牌',
        pleaseEnterStoreBrand: '请输入店铺品牌',
        storeEmail: '店铺邮箱',
        pleaseEnterStoreEmail: '请输入店铺邮箱',
        pleaseEnterFirstSyncTime: '请输入首次同步时间',
        SKUItemNumber: 'SKU货号',
        hour: '小时',
        onlineOrderImmediateDelivery: '在线下单后立即发货',
        onlyUseUSPS: '只用usps',
        pleaseEnterCountry: '请输入国家',
        pleaseSelectStatus: '请选择状态',
        pleaseSelectAutoSyncOrders: '请选择是否自动同步订单',
        pleaseEnterValidEmail: '请输入正确的邮箱地址',
        pleaseSelectProductSKUAssociation: '请选择商品SKU关联',
        pleaseSelectOnlineOrderDelayTime: '请选择在线下单延迟时间',
        pleaseSelectHostingMethod: '请选择托管方式',
        pleaseEnterProductInventoryToken: '请输入产品库存Token',
        pleaseSelectSyncOrderStatus: '请选择同步订单状态',
        pleaseDoNotSubmitAgain: '请勿重复提交',
        pleaseEnterOrderShippingToken: '必须要录入一个订单发货Token',
        priceStepGetTip: '[价格阶梯获取] 因一些物流因未揽收问题，我们会安排补做一次，再次产生未揽收问题。客户需自行承担。是否继续？',
        notice: '注意',
        shippingMethod: '物流下单方式',
        priceStepGetTip1: '价格阶梯获取（默认获取价格最低的渠道物流）',
        priceStepGetTip2: '由于燕文揽收率很低，所以此项会排除燕文物流',
        priceStepGetTip3: '[价格阶梯获取] 因一些物流因未揽收问题，我们会安排补做一次，再次产生未揽收问题。客户需自行承担。',
        pleaseEnterKeyword: '请输入搜索关键词',
        productsSKU: '产品SKU',
        relatedProducts: '关联产品',
        productName: '商品名称',
        unbind: '解绑',
        unbindProductTip: '解除产品绑定，是否继续？',
        templateName: '模版名称',
        selectedProductSKU: '选品SKU',
        to: '至',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
        uploadComplianceFile: '上传合规文件',
        viewFile: '查看文件',
        deleteComplianceFileTip: '删除选品合规文件是否继续？',
        selectedProductName: '选品名称',
        add: '新增',
        sync: '同步',
        warehouseName: '仓库名称',
        defaultWarehouse: '默认仓库',
        warehouseCode: '仓库代码',
        correspondingShippingFactory: '对应发货工厂',
        setDefault: '设置默认',
        setFactory: '设置工厂',
        setDefaultWarehouseTip: '设置为默认仓库是否继续？',
        TemuSynchronizationTip: 'Temu店铺同步仓库是否继续？',
        pleaseEnterMallID: '请输入mallid',
        TKAuthorization: 'TK授权',
        warning: '警告',
        authorizationTip: '考虑到登录Tik Tok店铺IP问题，最好复制此链接到您的VPN或者第三方浏览器进行操作',
        description: '说明：如果是全球商家或国内商家跨境到英国，授权时请选择',
        description1: 'Asia ---> Chinese mainland and the Hong Kong SAR (Cross-Border only)',
        copy: '复制',
        close: '关闭',
        storeType: '授权类型',
        notAmerican: "非美国",
        USCrossBorder: '美国（跨境）',
        PhilippinesCrossBorder: '菲律宾（跨境）',
        continentalUnitedStates: '美国（本土）',
        factory: '工厂',
        nationalTip: '会根据选择的国家同步工厂',


        importOrderTip: '请注意！因平台订单表格会存在变化，导入后，请核对订单信息和地址信息',
        importMethod: '导入方式',
        importPlatformOrder: '导入平台订单',
        importOfflineOrder: '导入线下订单',
        ImportMethod: '导入方式',
        importOrder: '导入订单',
        FileFormatTip: '请上传.txt, .xlsx, .xls格式',
        orderImportTemplate: '线下交易订单导入模板.xlsx',
        amazonOrderDownloadPath: '亚马逊订单后台下载路径： 订单报告-》 新订单',
        amazonOrderDownloadConfig: '亚马逊订单后台下载配置： 添加或删除订单报告列， 除 促销 其它都勾选',
        ebayOrderImportEnglish: 'ebay订单 导入英文版的订单',
        bindProductTip: '若一个平台sku 需要绑定多个不同的产品 ，请导入订单后 操作-》重新绑定产品',
        pleaseUploadFile: '请上传文件',
        pleaseEnterStoreNumber: '请输入店铺编号',
        pleaseSelectStore: '请选择店铺',
        checkImportOrderTip: '导入后请仔细核对产品信息和收货地址信息',
        noticeTip: '注意',
        confirm: '我已知晓',
        skipImportTip: '有{skip_nums}条订单跳过导入',
        productAPI: '产品API',
        productAPIAuthorization: '产品API授权',
        goAuthorization: '去授权',
        USOrderAPIAuthorization: '美区订单API授权',
        EUOrderAPIAuthorization: '欧区订单API授权',
        globalOrderAPIAuthorization: '全球订单API授权',
        temuShopType: 'Temu店铺类型',
        fullTruck: '全托管',
        halfTruck: '半托管',
        productToken: '产品token',
        orderToken: '订单token',
        authorizationTips: '*Temu生成Access Token有效期是90天，若秘钥过期需重新授权；',
        pleaseEnterToken: '请输入token',
        ozonAuthorization: 'Ozon授权',
        wildberriesAuthorization: 'Wildberries授权',
        userID: '用户识别号',
        APIKey: 'API密钥',


        shopeeAuthorization:'shopee授权'

    },

    main: {
        salesDataOverview: '销售数据一览',
        lastLoginLocation: '上次登录地点',
        lastLoginTime: '上次登录时间',
        todoItems: '待办事项',
        recent7DaysMetrics: '近7天产品行为指标',
        recommend: '推荐',
        changePassword: '修改密码',
        todaySales: '今日销售',
        orderCount: '单数',
        yesterdaySales: '昨日销售',
        thisWeekSales: '本周销售',
        thisMonthSales: '本月销售',
        itemCount: '件数',
        all: '全部',
        noNotification: '暂无公告通知',
        hotRecommend: '热卖推荐',
        newProductDelivery: '新品速递',
        hotSales: '热卖',
        viewDetail: '查看详情',
        newProduct: '新品',
        shippingCenter: '发货中心',
        designProductQuantity: '设计产品数量',
        designCategoryQuantity: '设计品类数量',
        elementUploadQuantity: '元素上传数量',
        designOrderEfficiency: '设计出单效率',
        categoryOrderEfficiency: '品类出单效率',
        elementOrderEfficiency: '元素出单效率',
    },

    acInfo: {
        myAccount: '我的账户',
        shippingMethod: '发货方式',
        downloadCenter: '下载中心',
        roleManagement: '角色管理',
        subAccountSetting: '子账号设置',
        myDistribution: '我的分销',
        senderInfo: '寄件人信息',
        userNumber: '用户编号',
        accountNumber: '账号',
        changePassword: '修改密码',
        phone: '手机',
        balance: '余额',
        recharge: '充值',
        withdraw: '提现',
        commission: '返佣',
        orderCommission: '订单佣金',
        shippingCommission: '物流返佣',
        shippingReturn: '物流返还',
        withdrawInfo: '提现信息',
        shippingAddress: '收货地址',
        name: '姓名',
        defaultAddress: '默认地址',
        country: '国家',
        state: '州/省',
        city: '城市',
        area: '区域',
        street: '街道',
        postcode: '邮编',
        mobilePhone: '手机号',
        address: '详细地址',
        editAddress: '修改地址',
        default: '默认',
        systemChannel: '系统渠道',
        ownChannel: '自有渠道',
        proxyChannel: '代理渠道',
        view: '查看',
        contactWay: '联系方式',
        open: '开启',
        close: '关闭',
        operator: '操作人',
        selectStatus: '选择状态',
        generating: '正在生成中',
        generated: '已生成',
        generateFailed: '生成失败',
        generateStatus: '生成状态',
        fileName: '文件名称',
        fileInfo: '文件信息',
        fileDownload: '文件下载',
        reGenerate: '重新生成',
        downloadCount: '下载次数',
        downloadRecord: '下载记录',
        downloadTime: '下载时间',
        operatorTime: '操作时间',
        roleNumber: '角色编号',
        roleName: '角色名称',
        sort: '排序',
        operation: '操作',
        permission: '权限',
        createSubAccount: '创建子账号',
        username: '用户名',
        account: '账号',
        pleaseSelectRole: '请选择角色',
        accountStatus: '账号状态',
        normal: '正常',
        disabled: '禁用',
        role: '账户角色',
        createTime: '创建时间',
        resetPassword: '重置密码',
        sharedAccountData: '共享账号数据',
        companyName: '公司名称',
        distributionAccount: '分销账户',
        identifier: '标识',
        level: '等级',
        logisticsChannel: '物流渠道',
        accountBalance: '账户余额',
        distributionDataStatistics: '分销数据统计',
        totalOrders: '总出单',
        totalItems: '总件数',
        totalCancelItems: '总取消件数',
        currentMonthCancelItems: '当月取消件数',
        totalRecharge: '总充值',
        totalExpenditure: '总支出',
        currentMonthOrders: '当月出单',
        currentMonthItems: '当月件数',
        totalPayOrders: '支付生产总单数',
        totalPayItems: '支付生产总件数',
        currentMonthPayOrders: '当月支付单数',
        currentMonthPayItems: '当月支付件数',
        viewLastMonthData: '查看上月数据',
        lastMonthOrders: '上月出单',
        lastMonthItems: '上月件数',
        lastMonthCancelItems: '上月取消件数',
        lastMonthPayOrders: '上月支付生产总单数',
        lastMonthPayItems: '上月支付生产总件数',
        lastMonthTotalRecharge: '上月总充值',
        lastMonthTotalExpenditure: '上月总支出',
        distributionAccounts: '分销账户',
        accountNickname: '账户昵称',
        mainAccount: '主账户',
        remark: '备注',
        createdTime: '创建时间',
        pickUpInfo: '选品信息',
        viewOrder: '查看订单',
        logOff: '注销',
        pleaseUseEnglishOrPinyin: '请用英文或拼音填写寄件信息',
        senderName: '寄件人姓名',
        senderState: '寄件人省',
        senderCity: '寄件人城市',
        company: '公司名称',
        email: '邮箱',
        addressDetail: '详细寄件地址',
        withdrawType: '提现类型',
        orderCommissionAmount: '订单返佣金额',
        shippingCommissionAmount: '物流返佣金额',
        shippingReturnFee: '物流返还费用',
        withdrawAmount: '提现金额',
        yuan: '元',
        orderCommissionWithdrawableAmount: '订单返佣可提现金额',
        shippingCommissionWithdrawableAmount: '物流返佣可提现金额',
        shippingReturnFeeWithdrawableAmount: '物流返还费用可提现金额',
        alipay: '支付宝',
        bankCard: '银行卡',
        wechat: '微信',
        accountInfo: '账号信息',
        oldPassword: '旧密码',
        newPassword: '新密码',
        confirmNewPassword: '确认新密码',
        submit: '提交',
        recipient: '收件人',
        region: '所在地区',
        setDefault: '设为默认',
        cancelDefault: '取消默认',
        deleteAddressConfirm: '删除收货地址，是否继续?',
        pleaseSelectPermission: '请选择权限！！！',
        deleteLabel: '删除标签，是否继续?',
        password: '密码',
        userName: '用户名称',
        orderInfo: '订单信息',
        distributionCompanyName: '分销公司名称',
        accountName: '账户名',
        accountPassword: '账户密码',
        phoneNumber: '手机号',
        deliverWay: '发货方式',
        customerDescription: '客户说明',
        phoneNumberCannotBeEmpty: '手机号不能为空',
        pleaseCorrectPhoneNumber: '请输入正确的手机号',
        pleaseEnterCategoryName: '请输入分类名',
        accountNameOrPinyin: '账户名不能包含中文以及中文字符',
        pleaseEnterAccountName: '请输入账户名',
        pleaseEnterUserName: '请输入用户名',
        pleaseEnterPassword: '请输入密码',
        pleaseSelectDeliverWay: '请选择发货方式',
        pleaseSelectOpenPick: '请选择开放选品',
        productName: '商品名称',
        productSku: '商品SKU',
        templateCategory: '模版分类',
        productInfo: '产品信息',
        adjustDistributionPrice: '调整分销价',
        craft: '工艺',
        pickUpPrice: '拿货价',
        distributionPrice: '分销价格（￥）',
        lowerLevelDistributionPrice: '下级分销价格（￥）',
        profit: '利润（￥）',
        shopName: '店铺名称',
        platformShopOperator: '平台/店铺/运营人',
        time: '时间',
        platformOrderTime: '平台下单时间',
        systemSyncTime: '系统同步时间',
        latestDeliveryTime: '最迟发货时间',
        processSize: '工艺/款式/尺码',
        orderProductInfo: '订单产品信息',
        quantity: '数量',
        price: '价格（￥）',
        status: '状态',
        pending: '待处理',
        designing: '设计中',
        designCompleted: '设计完成',
        productionCompleted: '已入生产',
        qualityInspection: '质检中',
        pendingDelivery: '待发货',
        delivered: '已发货',
        cancelled: '已取消',
        factory: '工厂',
        orderNumber: '订单号',
        delivery: '交货',
        distributionInfo: '分销信息',
        totalStoreNums: '店铺数量',
        totalPicSize: '图片空间',
        totalChildrenAccount: '子账号数量',
        userQuota: '用户额度',
    },

    v_header: {
        goHome: '去首页',
        shoppingCart: '购物车',
        processingCenter: '处理中心',
        productPendingGeneration: '产品待生成',
        handle: '处理',
        notification: '消息通知',
        youAreWelcome: '你好！',
        balance: '余额',
        unit: '元',
        rebate: '返佣',
        freezeAmount: '冻结{ frozen_money }（元）查看',
        accountInfo: '账户信息',
        transactionRecords: '交易记录',
        logOff: '退出登录',
    },

    shoppingCart: {
        shoppingCart: '购物车',
        product: '产品',
        name: '名称',
        shippingCenter: '发货中心',
        pickUpSku: '选品SKU',
        productIdentifier: '产品标识',
        compositeProductId: '组合产品ID',
        processSize: '工艺/尺码',
        craft: '工艺',
        size: '尺码',
        price: '价格(￥)',
        quantity: '数量',
        addTime: '添加时间',
        operation: '操作',
        delete: '删除选中的商品',
        totalPrice: '总价',
        checkout: '结算',
        pleaseSelectItems: '请勾选需要操作的项',
        confirmDelete: '删除购物车，是否继续?',
        checkoutPriceException: '结算数据价格异常，请联系管理员处理',
        checkoutFactoryException: '不同工厂无法结算生产',
        pleaseSelectCheckoutItems: '请选择结算的产品',
    },

    checkout_cart: {
        checkoutCart: '购物车结算',
        productInfo: '商品信息',
        name: '名称',
        shippingCenter: '发货中心',
        pickUpSku: '选品SKU',
        productIdentifier: '产品标识',
        compositeProductId: '组合产品ID',
        processSize: '工艺/尺码',
        price: '价格(￥)',
        unitPrice: '单价(￥)',
        quantity: '数量',
        subTotal: '小计',
        operation: '操作',
        orderBelong: '订单归属',
        platformOrderNumber: '平台订单号',
        optional: '选填，输入的内容将生成平台订单号',
        shop: '店铺',
        shopTip: '账户中没有店铺，结算购物车会自动创建一个自助店铺',
        deliveryMethod: '发货方式',
        shipments: '发货',
        FBAShipping: 'FBA发货',
        pickUp: '自提',
        preOrder: '备货',
        recipientInfo: '收件人信息',
        preOrderTip: '商品备货生产完成后会暂存至众飞腾仓库，便于后期出单快速发货',
        orderTotal: '订单总计',
        submit: '提交订单',
        pleaseAddress: '请选择发货地址',
        confirmSubmit: '购物车提交成功，已生成订单?',
        goToOrderView: '前往订单查看',
        returnToShoppingCart: '返回购物车',
    },

    recharge: {
        recharge: '账户充值',
        accountInformation: '账户信息',
        rechargeAccount: '充值账号',
        availableBalance: '可用余额',
        onlinePayment: '线上支付',
        bankTransfer: '银行转账（线下汇款）',
        rechargeAmount: '充值金额',
        unit: '元',
        customAmount: '自定义金额',
        minimumRechargeAmount: '最低充值不低于10元的整数金额',
        paymentMethod: '支付方式',
        paymentAmount: '支付金额',
        immediatePayment: '立即支付',
        companyInfo: '我司信息',
        companyName: '公司名称',
        bankName: '银行名称',
        bankAccount: '银行账号',
        openingBank: '开户银行',
        prompt: '温馨提示：为确保您的资金及时到账，请汇款后保留截图并联系业务员进行入账操作；如有疑问请联系在线客服或业务经理。',
        pleaseInformation: '请先配置支付信息',
    },
}